import React from 'react'
import PropTypes from 'prop-types'
import ErrorDisplay from '../ErrorDisplay'
import './AddDomainResourceForm.css'
import 'font-awesome/css/font-awesome.css'

const AddDomainResourceForm = (props) => {

	const submit = (evt) => {
		evt.preventDefault()
		props.submit(props.resourceUrl)
	}

	const resourceUrlChanged = (evt) => {
		props.resourceUrlChanged(evt.target.value)
	}

	return (
		<form className="form" onSubmit={submit}>
			<p className="field">
				<input className="resourceUrl" type="text" onChange={resourceUrlChanged} value={props.resourceUrl} placeholder="Resource URL" name="resourceUrl" id="resourceUrl" disabled={props.disabled}/>
				<i className="fa fa-file fa-lg"/>
			</p>
			<p className="submit">
				<button className="submitResourceUrl" type="submit" disabled={props.disabled}>
					<i className="fa fa-arrow-right fa-lg"/>
				</button>
			</p>
			<ErrorDisplay err={props.err}/>
		</form>
	)
}

AddDomainResourceForm.propTypes = {
	resourceUrl: PropTypes.string.isRequired,
	submit: PropTypes.func.isRequired,
	resourceUrlChanged: PropTypes.func.isRequired,
	disabled: PropTypes.bool.isRequired
}

export default AddDomainResourceForm





// WEBPACK FOOTER //
// ./src/components/AddDomainResourceForm/AddDomainResourceForm.js